<script>
import { Sortable, Plugins } from '@shopify/draggable';
import FavoriteAction from '../FavoriteAction.vue';
import MyResources from './MyResources.vue';
import MyShortcuts from './MyShortcuts.vue';

export default {
    name: 'Dashboard',
    components: {
        FavoriteAction,
        MyResources,
        MyShortcuts,
    },
    props: {
        dashboardOrder: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            order: [],
        };
    },
    mounted() {
        this.order = this.dashboardOrder;
        const dashboard = new Sortable(this.$refs.dashboard, {
            draggable: '.dashboardSection',
            handle: '.dashboardSection__dragHandle',
            mirror: {
                constrainDimensions: true,
            },
            plugins: [Plugins.SwapAnimation],
            swapAnimation: {
                duration: 200,
                easingFunction: 'ease-in-out',
            },
        });

        dashboard.on('sortable:stop', ({ newIndex, oldIndex }) => {
            this.order.splice(newIndex, 0, ...this.order.splice(oldIndex, 1));
            this.updateDashboardOrder();
        });
    },
    methods: {
        updateDashboardOrder() {
            axios.post('/api/preferences', {
                dashboardOrder: this.order,
            }).catch(error => {
                console.warn(error);
            });
        },
    },
};
</script>
